<template>
  <nav class="top-0 w-full fixed z-20">
    <div class="navBar">
      <span
        class="
          lg:max-w-screen-xl
          m-auto
          flex
          items-center
          justify-between
          flex-wrap
          py-6
          px-5
          max-w-2xl
        "
      >
        <div class="flex items-center flex-shrink-0 lg:mr-6">
          <router-link
            to="/"
            id="logo"
            class="font-serif border-none text-2xl tracking-wide"
            >Haus Morgensonne</router-link
          >
        </div>
        <div class="block bg-red">
          <button
            class="flex items-center px-3 py-2 border border-transparent"
            @click="collapsed = !collapsed"
          >
            <svg
              class="fill-current h-5"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menü</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
        <div :class="collapsed ? 'collapsed' : 'open'">
          <ul class="text-2xl pb-20" @click="collapsed = !collapsed">
            <li class="py-2">
              <router-link to="/">Start</router-link>
            </li>
            <li class="py-2">
              <router-link to="/haus">Wohnhaus</router-link>
            </li>
            <li class="py-2">
              <router-link to="/ferienwohnung">Ferienwohnung</router-link>
            </li>
            <li class="py-2">
              <router-link to="/ueber-uns">Über uns</router-link>
            </li>
            <li class="py-2">
              <router-link to="/die-region">Die Region</router-link>
            </li>
            <li class="py-2">
              <router-link to="/kontakt">Kontakt</router-link>
            </li>
          </ul>
        </div>
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavbarMobile',
  data() {
    return {
      collapsed: true,
    }
  },
}
</script>
<style scoped>
#logo {
  @apply font-normal;
}
.collapsed {
  @apply w-full hidden duration-150 ease-in-out flex-grow;
}

.open {
  @apply w-full flex-grow text-center text-lg flex flex-col justify-center z-50;
  height: 100vh
}

.navBar {
  @apply text-gray-800 bg-white border-b-2 border-red-500;
}
.navBar li {
  @apply block mt-3 text-gray-600 font-bold transition-colors duration-300 ease-in-out;
}
.navBar a.router-link-exact-active {
  @apply text-gray-900 py-1 border-b border-red-500 font-bold transition-colors duration-200 ease-in-out;
}
.navBar li:hover {
  @apply text-gray-800;
  @apply transition-colors;
  @apply duration-300;
}
.navBar li:focus {
  @apply text-blue-700;
}

@screen lg {
  li {
    @apply inline-block mt-0 pl-12;
  }
  .collapsed,
  .open {
    @apply flex items-center w-auto;
  }
}
</style>
